module.exports = "./img/23441d0a791cf1de36ada57addf374f9.jpg";